<div class="image-upload">
    <input
        type="file"
        style="width: 100%"
        [accept]="accept()"
        [disabled]="isDisabled"
        hidden
        #fileInput
        (change)="onImageFileSelected($event)"
        (cancel)="$event.stopPropagation()"
    />

    @if (file && previewUrl()) {
        <div class="preview">
            <img
                [src]="previewUrl()"
                alt="Image Preview"
                [ngStyle]="{
                    height: fileFormat() === 'png' ? 'unset' : '100px',
                }"
            />
            <ai-button
                [transparent]="true"
                [shape]="'round'"
                [border]="'hidden'"
                [disabled]="isDisabled"
                (click)="clear()"
            >
                <ai-icon [fontIcon]="'ai-icon-trash'" />
            </ai-button>
        </div>
    }
    @if (!file) {
        <ai-button
            [type]="'button'"
            [label]="'Selecionar Imagem'"
            [size]="'small'"
            [shape]="'base-rounder'"
            (click)="fileInput.click()"
            [disabled]="isDisabled"
        />
    }
</div>
